import httpAdminClient from "@/plugins/httpAdminClient";

export default {
  index(currentPage, perPage) {
    return httpAdminClient.get(
      `admin/stat/orgs?page=${currentPage}&per_page=${perPage}`
    );
  },
  show(id) {
    return httpAdminClient.get(`admin/stat/orgs/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/stat/api-orgs.js